module.exports = __webpack_public_path__ + "static/media/fire.a758447d.svg";